function Container({ children }) {
  return <div className="container mx-auto p-5">{children}</div>;
}

export default Container;
